var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('header',{ref:"header",class:{ opaque: true }},[_c('h1',{staticClass:"label"},[_vm._v(_vm._s(_vm.label))]),(true)?_c('p',[_vm._v(_vm._s(_vm.$t("header.subtitle")))]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }